"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'LeftNav'
});
schema.propTypes = {
  currentPath: _reactDesc.PropTypes.string.description("The current pathname of the user's location. When this value matches a `path` attribute for a menu item or sub item, that item will render in active status in the left nav").isRequired,
  defaultNavExpandedState: _reactDesc.PropTypes.oneOf(['COLLAPSED_XY', 'COLLAPSED_X', 'EXPANDED']).description('A default value used to initialize the expanded state of the nav. Will respect screen size/ user choice after first render.'),
  navExpandedState: _reactDesc.PropTypes.oneOf(['COLLAPSED_XY', 'COLLAPSED_X', 'EXPANDED']).description('A value used to control the expanded state of the nav. If provided, will always override internal values'),
  onChangeNavExpandedState: _reactDesc.PropTypes.func.description('An event handler used to track when a user requests a change to the nav expanded state. Will not be called when the nav expanded state changes based on screen size.'),
  items: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    active: _reactDesc.PropTypes.bool.description('Sets the menu item as active.'),
    disabled: _reactDesc.PropTypes.bool.description('Disables the menu item.'),
    icon: _reactDesc.PropTypes.func.description('Which `iconix` icon to render.').isRequired,
    text: _reactDesc.PropTypes.string.description('The label for the menu item.').isRequired,
    path: _reactDesc.PropTypes.string.description('The path for an internal link. Can not be used with a `url` attribute.'),
    url: _reactDesc.PropTypes.string.description('The path for an external link. Can not be used with a `path` attribute.'),
    items: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
      active: _reactDesc.PropTypes.bool.description('Sets the menu item as active.'),
      disabled: _reactDesc.PropTypes.bool.description('Disables the menu subitem.'),
      text: _reactDesc.PropTypes.string.description('The label for the menu subitem.').isRequired,
      path: _reactDesc.PropTypes.string.description('The path for an internal link. Can not be used with a `url` attribute.'),
      url: _reactDesc.PropTypes.string.description('The path for an external link. Can not be used with a `path` attribute.')
    }).description('The definition for a subitem.')).description('An optional array of subitems.')
  }).description('The definition for items.')).description('An array of menu item definitions.').defaultValue('[]')
};
var _default = schema;
exports.default = _default;